export default {
  title: 'Renomear',
  form: {
    label: {
      title: 'Título *',
      description: 'Descrição (opcional)',
    },
    rule: {
      emptyTitle: 'O título é obrigatório',
      titleMaxCharacters: 'O título deve ter até %{titleMaxCharacters} caracteres',
      descriptionMaxCharacters: 'A descrição deve ter até %{descriptionMaxCharacters} caracteres',
    },
  },
  label: {
    button: {
      confirmButton: 'Salvar',
      cancelButton: 'Cancelar',
    },
  },
};
